import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import Catalog2 from "@/pages/Catalog2";
import ThrustCatalog from "@/pages/ThrustCatalog";
import AsusCatalog from "@/pages/AsusCatalog";
import FBMondialCatalog from "@/pages/FBMondialCatalog";
import RDBElectricCatalog from "@/pages/RDBElectricCatalog";
import BikeDetail from "@/pages/BikeDetail";
import ServiceBooking from "@/pages/ServiceBooking";
import TestRide from "@/pages/TestRide";
import About from "@/pages/About";
import NotFound from "@/pages/NotFound";

import { AuthProvider } from "@/contexts/AuthContext";
import { SiteContentProvider } from "@/contexts/SiteContentContext";
import PopupModal from "@/components/PopupModal";
import DashboardLogin from "@/pages/dashboard/Login";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import ProtectedRoute from "@/pages/dashboard/ProtectedRoute";
import Overview from "@/pages/dashboard/Overview";
import BikesManager from "@/pages/dashboard/BikesManager";
import BikeForm from "@/pages/dashboard/BikeForm";
import ContentEditor from "@/pages/dashboard/ContentEditor";
import Bookings from "@/pages/dashboard/Bookings";

function PublicShell({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <PopupModal />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0A0A] text-white">
      <BrowserRouter>
        <SiteContentProvider>
          <AuthProvider>
            <Routes>
              {/* Dashboard (no public header/footer) */}
              <Route path="/dashboard/login" element={<DashboardLogin />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <DashboardLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Overview />} />
                <Route path="bikes" element={<BikesManager />} />
                <Route path="bikes/new" element={<BikeForm />} />
                <Route path="bikes/:id/edit" element={<BikeForm />} />
                <Route path="content" element={<ContentEditor />} />
                <Route path="bookings" element={<Bookings />} />
              </Route>

              {/* Public site */}
              <Route path="/" element={<PublicShell><Home /></PublicShell>} />
              <Route path="/catalog" element={<PublicShell><Catalog /></PublicShell>} />
              <Route path="/thrust" element={<PublicShell><ThrustCatalog /></PublicShell>} />
              <Route path="/fb-mondial" element={<PublicShell><FBMondialCatalog /></PublicShell>} />
              <Route path="/asus" element={<PublicShell><AsusCatalog /></PublicShell>} />
              <Route path="/rdb-electric" element={<PublicShell><RDBElectricCatalog /></PublicShell>} />
              <Route path="/catalog2" element={<PublicShell><Catalog2 /></PublicShell>} />
              <Route path="/catalog/:id" element={<PublicShell><BikeDetail /></PublicShell>} />
              <Route path="/service" element={<PublicShell><ServiceBooking /></PublicShell>} />
              <Route path="/test-ride" element={<PublicShell><TestRide /></PublicShell>} />
              <Route path="/test-ride/:bikeId" element={<PublicShell><TestRide /></PublicShell>} />
              <Route path="/about" element={<PublicShell><About /></PublicShell>} />
              <Route path="*" element={<PublicShell><NotFound /></PublicShell>} />
            </Routes>
          </AuthProvider>
        </SiteContentProvider>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#141414",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#fff",
              borderRadius: "2px",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
